import React, { Component } from "react";
import "./SubUserMgmt.css";
import { Table, Nav } from "react-bootstrap";
import Delete from "../../image/delete.svg";
import { Link } from "react-router-dom";
import Usersiconimg from "../../image/users.svg";

class UserMgmt extends Component {
  constructor() {
    super();
    this.state = {
      list: null,
    };
  }

  async ge() {
    const res = await fetch("./users.json");
    const data = await res.json();
    this.setState({
      list: data,
    });
  }

  componentDidMount() {
    this.ge();
  }

  render() {
    return (
      <div className="container usermain">
        <div className="row">
          <div className="col-1">
            <div className="userlogo">
              <img src={Usersiconimg} alt="" className="userlogoicon" />
            </div>
          </div>

          <div className="col-11">
            <div className="usersearchsec">
              <span className="usertitle">Users</span>
              <Link to="/new-users" className="UserManagementTDU">
                <span className="UserMgmtNewUsers">+ New Users</span>
              </Link>
            </div>
            <Table responsive className="userMgmtable">
              {Array.from({ length: 1 }).map((_, index) => (
                <thead className="userMgmtDesc">
                  <td style={td}>Role</td>

                  <td style={td}>Description</td>

                  <td style={td}>Action</td>
                </thead>
              ))}
            </Table>

            {this.state.list ? (
              <div>
                {this.state.list.map((item, i) => (
                  <Table responsive className="d-block userMgmtable">
                    {Array.from({ length: 1 }).map((_, index) => (
                      <tbody className="userMgmtDesc">
                        <td style={td}>{item.role}</td>

                        <td style={td}>{item.desc}</td>

                        <td style={td}>
                          <Nav.Link className="usersiconupdate">
                            <Link to="/delete" className="usersdelete">
                              <img src={Delete} alt="" />
                            </Link>
                          </Nav.Link>
                        </td>
                      </tbody>
                    ))}
                  </Table>
                ))}
              </div>
            ) : (
              <p>please wait....</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const td = {
  textAlign: "center",
  display: "grid",
  alignContent: "center",
  margin: "10px 0px",
};

export default UserMgmt;
